import React from "react"
import PropTypes from "prop-types"

import styles from "./styles.css"
import parentStyles from "../styles.css"

const DateTime = ({ dates, formik }) => {
  const { touched, errors, values, setFieldValue, setErrors, handleBlur } =
    formik
  const isErrorFieldDate = touched.date && errors.date
  const isErrorFieldTime = touched.time && errors.time
  const dateKeys = dates && Object.keys(dates)
  const isDateFiled = values.date && values.date !== ""

  const handleChange = (event) => {
    const { name, value } = event.target

    if (!value) {
      return
    }

    setFieldValue(name, value, true)

    const updatedErrors = { ...errors }
    if (updatedErrors[name]) {
      delete updatedErrors[name]
      setErrors(updatedErrors)
    }
  }

  return (
    <div>
      <div className={parentStyles.line}>
        <div>
          <select
            className={`${styles.select_date} ${styles.select_fixed_voice}`}
            name="date"
            onChange={(e) => {
              handleChange(e)
            }}
            onBlur={handleBlur}
          >
            <option defaultValue className={styles.custom_option} value="">
              Escolha o dia
            </option>
            {dateKeys &&
              dateKeys.map((date, i) => (
                <option key={i} value={`${date}`}>
                  {date}
                </option>
              ))}
          </select>
          {isErrorFieldDate && (
            <div className={`${parentStyles.error}`}>{errors.date}</div>
          )}
        </div>
        <div>
          <select
            className={`${styles.select_hour} ${styles.select_fixed_voice}`}
            name="time"
            onChange={(e) => {
              handleChange(e)
            }}
            onBlur={handleBlur}
            disabled={!isDateFiled}
          >
            <option defaultValue className={styles.custom_option} value="">
              Escolha a hora
            </option>
            {dates &&
              isDateFiled &&
              dates[values.date].map((time, i) => (
                <option key={i} value={`${time.originalDate}`}>
                  {time.hour}
                </option>
              ))}
          </select>
          {isErrorFieldTime && (
            <div className={`${parentStyles.error}`}>{errors.time}</div>
          )}
        </div>
      </div>
    </div>
  )
}

DateTime.propTypes = {
  dates: PropTypes.object,
  formik: PropTypes.object
}

export default DateTime



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/DateTime/index.js